<template>
    <div class="card-data download-card">
        <div class="header">
            <div class="icon-holder">
                <div class="circle">
                    <div class="innercircle">
                        <i class="icon ico-download"></i>
                    </div>
                </div> 
            </div>
            <div class="title-holder">
                <p class="title">{{title}}</p>
                <p class="subtitle">{{rangeTitle}}</p>
            </div>
        </div>
        
        <a class="button sm secondary" :href="urlData" :click="true" v-if="downloadType==0">
            <p>Descargar</p>
        </a>

        <button class="button sm secondary" @click="csvPresenceExport()" v-if="downloadType==1 || downloadType==2">
            <p>Descargar</p>
        </button>

        <button class="button sm secondary" @click="csvClusterExport()" v-if="downloadType==3 || downloadType==4 || downloadType==5">
            <p>Descargar</p>
        </button>
        
        
    </div>
</template>
<script>
import _default, { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'DownloadCard',
    data: function(){
        return {
            clusterArray: [],
        }
    },
    components: {
    },
    created: function(){
        this.$store.dispatch("auth/setActive", "clusters");
        this.getClusters().then(r => {
                this.clusterArray = this.getAllClusters
            }, err => {
                console.log(err)
            })
    },
    props: {
        title: {
            type: String,
            default: "Título"
        },
        dataDownload: {
            type: String,
        },
        initRange:{
            type: [Date,String],
            default: moment().format("YYYY-MM-DD")
        },
        endRange:{
            type: [Date,String],
            default: moment().format("YYYY-MM-DD")
        },
        download:{
            type: Boolean,
            default: false
        },
        downloadType:{
            type: Number,
            default: 0
        }
    },
    computed:{
        urlData: function(){
            return process.env.VUE_APP_ANALYTICS_HOST+this.dataDownload
        },
        rangeTitle: function(){
            let monthNames = [
                                "Ene", "Feb", "Mar",
                                "Abr", "May", "Jun", "Jul",
                                "Ago", "Sep", "Oct",
                                "Nov", "Dic"
                            ]
            if (this.initRange != this.endRange) {
                return this.initRange.split('-')[2] +
                    "-" +
                    monthNames[this.initRange.split('-')[1] - 1] +
                    " al " +
                    this.endRange.split('-')[2] +
                    "-" +
                    monthNames[this.endRange.split('-')[1] - 1]
            }
            return this.initRange.split('-')[2] +
                    "-" +
                    monthNames[this.initRange.split('-')[1] - 1]
        },
        allClusters: function(){
            var clusters = this.clusterArray;
            try {
                this.selectedCluster = clusters[0].name
                this.selectedClusterVenues = clusters[0].clusters   
            } catch (error) {
                
            }
            return clusters;
        },
        ...mapGetters('clusters', {
            'getClusterFilter': 'getClusterFilter',
            'getAllClusters': 'allClusters',
            'getCluster': 'getSelectedCluster',
        }),
    },
    methods: {
        thousandseparatos: function(num){
            var num_parts = num.toString().split(".");
            num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return num_parts.join(".");
        },
        checkValue: function(value,arr){
            var status = false;
            
            for(var i=0; i<arr.length; i++){
                var name = arr[i];
                if(name == value){
                status = true;
                break;
                }
            }

            return status;
        },
        csvPresenceExport: async function() {

            let csvExportTranseuntes = []
            let csvExportVisitantes = []
            let csvExportCaptureRate = []
            let csvExportDataRecurrents = []
            let csvExportDataNotRecurrents = []
            let csvExportDataPeriods = []
            
            let totalTranseuntes = 0
            let totalVisitantes = 0
            let totalCaptureRate = 0
            let totalRecurrents = 0
            let totalNotRecurrents = 0

            try{
                let headers = {'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'}
            
                // Recurrents - not Recurrents
                const recurrents = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/infrastructure/recurrents/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id=999999", {headers:headers})
                _.each(recurrents.data, async(value) => {
                    csvExportDataRecurrents.push({'period':value.period,'value':value.recurrents})
                    csvExportDataNotRecurrents.push({'period':value.period,'value':value.not_recurrents})
                })

                // Visitors
                const visitors = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/visitors/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id=999999", {headers:headers})
                totalVisitantes = _.sumBy(visitors.data, function(obj) { return obj.value})
                _.each(visitors.data, async(value) => {
                    csvExportVisitantes.push(value)
                })
                
                // Transeúntes
                const passerBy = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/passer_by/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id=999999", {headers:headers})
                totalTranseuntes = _.sumBy(passerBy.data, function(obj) { return obj.value})
                _.each(passerBy.data, async(value) => {
                    csvExportDataPeriods.push(value.period)
                    csvExportTranseuntes.push(value)
                })

                _.each(csvExportTranseuntes, (passer) => {
                    _.each(csvExportVisitantes, (visitor) => {
                        if(passer.period.indexOf(visitor.period)==0){
                        
                        var capture_rate = Math.round((visitor.value * 100) / (passer.value + visitor.value))
                        if (isNaN(capture_rate)){
                            capture_rate = 0
                        }
                        
                        csvExportCaptureRate.push({'period':passer.period,'value':capture_rate})

                        }
                    })
                })
                
                _.each(csvExportCaptureRate, (value) => {
                totalCaptureRate = totalCaptureRate + value.value
                })

                _.each(csvExportDataRecurrents, (value) => {
                totalRecurrents = totalRecurrents + value.value
                })

                _.each(csvExportDataNotRecurrents, (value) => {
                totalNotRecurrents = totalNotRecurrents + value.value
                })

                let periodRecurrentNotrecurrent = []
                
                _.each(csvExportDataPeriods, (value) => {
                let period = {}
                period["Período"] = value
                
                _.each(csvExportTranseuntes, (value) => {
                    if (period["Período"] === value.period){
                        period["Transeúntes"] = this.thousandseparatos(value.value)
                    }
                })

                _.each(csvExportVisitantes, (value) => {
                    if (period["Período"] === value.period){
                        period["Visitantes"] = this.thousandseparatos(value.value)
                    }
                })

                _.each(csvExportCaptureRate, (value) => {
                    if (period["Período"] === value.period){
                        period["Capture_rate"] = value.value.toString()+"%"
                    }
                })

                _.each(csvExportDataRecurrents, (value) => {
                    if (period["Período"] === value.period){
                        period["Recurrentes"] = this.thousandseparatos(value.value)
                    }
                })

                _.each(csvExportDataNotRecurrents, (value) => {
                    if (period["Período"] === value.period){
                        period["No_recurrentes"] = this.thousandseparatos(value.value)
                    }
                })

                periodRecurrentNotrecurrent.push(period)
                
                })

                let capturePercentage = (totalCaptureRate / csvExportCaptureRate.length).toFixed(0).toString()+"%"

                let spaceperiod = {}
                spaceperiod["Período"] = ""
                spaceperiod["Transeúntes"] = ""
                spaceperiod["Visitantes"] = ""
                spaceperiod["Capture_rate"] = ""
                spaceperiod["Recurrentes"] = ""
                spaceperiod["No_recurrentes"] = ""
                periodRecurrentNotrecurrent.push(spaceperiod)

                let totalperiod = {}
                totalperiod["Período"] = "Total"
                totalperiod["Transeúntes"] = this.thousandseparatos(totalTranseuntes)
                totalperiod["Visitantes"] = this.thousandseparatos(totalVisitantes)
                totalperiod["Capture_rate"] = capturePercentage
                totalperiod["Recurrentes"] = this.thousandseparatos(totalRecurrents)
                totalperiod["No_recurrentes"] = this.thousandseparatos(totalNotRecurrents)
                periodRecurrentNotrecurrent.push(totalperiod)

                let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                Object.keys(periodRecurrentNotrecurrent[0]).join(";"),
                ...periodRecurrentNotrecurrent.map(item => Object.values(item).join(";"))
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", moment().format('DD-MM-YYYY')+"_Notros_Presencia.csv");
                link.click();
				
			}
			catch (err){
				console.log(err)
			}
            
        },
        csvClusterExport: async function() {

            let clusters = this.clusterArray;
            let total = 0

            let loadedCount = 0

            _.each(clusters, async(cluster, csindex) => {
                
                let storeSessionsProm = []
                let storeRevenue = []
                let totalSessionsProm = 0

                let storeRecurrentsProm = []
                let totalRecurrentsProm = 0

                let storeNotRecurrentsProm = []
                let totalNotRecurrentsProm = 0
                let conectionsProm = []
                total = 0

                let totalRecurrents = 0
                let totalNotRecurrents = 0
                let recurrentsProm = []
                let notRecurrentsProm = []

                let totalRevenue = 0

                let dataRevenue = 0
                let periodRevenue = []
                let revenueChartData = []

                let barChartData = [{
                    'name': 'data',
                    'data': []
                }, ]

                let periodBarChartData = []

                let lineChartData = [{
                    'name': 'Conexiones',
                    'data': []
                }, ]
                let periodLineChartData = []

                let totalClicks = 0

                    _.each(cluster.stores, async(storeValue, cindex) => {

                        let headers = {'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'}
            
                        // Sessions
                        const sessions = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/sessions/?init_date="+this.initRange+"&end_date="+this.endRange+"&offer_id=999999&store_id="+storeValue.id, {headers:headers})
                        _.each(sessions.data, async(value, dindex) => {
                                total = total + value["not_customer"]
                                conectionsProm.push(value["not_customer"])
                                totalSessionsProm = totalSessionsProm + value["not_customer"]

                                if(cluster.stores.length==cindex+1){
                                    periodLineChartData.push(value["period"])
                                }

                                if(lineChartData[0].data[dindex]!=undefined){
                                    lineChartData[0].data[dindex] = lineChartData[0].data[dindex] + sessions.data[dindex]["not_customer"]
                                }else{
                                    lineChartData[0].data[dindex] = sessions.data[dindex]["not_customer"]
                                }
                        })

                        storeSessionsProm.push(total)

                        // Visitors
                        const visitors = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/visitors/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id="+storeValue.id, {headers:headers})
                        _.each(visitors.data, async(value, index) => {
                            let sumConnection = 0;
                            _.each(visitors.data, async(value, index) => {
                                sumConnection = sumConnection + value.value
                            })
                            totalRecurrents = sumConnection
                            totalRecurrentsProm = sumConnection
                        })
                        storeRecurrentsProm.push(totalRecurrents)

                        // Not Visitors
                        const passers = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/visitors/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id="+storeValue.id, {headers:headers})
                        _.each(passers.data, async(value, index) => {
                            let sumConnection = 0;
                            _.each(passers.data, async(value, index) => {
                                sumConnection = sumConnection + value.value
                            })
                            totalNotRecurrents =  sumConnection
                        })
                        storeNotRecurrentsProm.push(totalNotRecurrents)

                        // Offers
                        const offers = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/?init_date="+this.initRange+"&end_date="+this.endRange+"&store_id="+storeValue.id+"&offer_id=999999", {headers:headers})
                        _.each(offers.data, async(rvalue, i) => {
                            totalRevenue = totalRevenue + rvalue["revenue"]
                            if(cluster.stores.length==cindex+1){
                                periodRevenue.push(rvalue["period"])
                            }

                            if(revenueChartData[i]!=undefined){
                                revenueChartData[i] = revenueChartData[i] + offers.data[i]["revenue"]
                            }else{
                                revenueChartData[i] = offers.data[i]["revenue"]
                            }
                        })

                        storeValue.revenue = totalRevenue.toFixed(0)
                        storeRevenue.push(totalRevenue)

                        // offers content
                        const offers_content = await axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/content/?init_date="+this.initRange+"&end_date="+this.endRange+"&offer_id=999999&store_id="+storeValue.id, {headers:headers})
                        
                        _.each(offers_content.data, async(clivalue, i) => {
                            totalClicks = totalClicks + clivalue["clicks"]
                        })

                        let periodContent = []
                        let clicksChartDataItems = [
                            {
                                'name': 'Interacciones',
                                'data': []
                            }
                        ]

                        let clicksChartData = []

                        let offerIds = []
                        
                        _.each(offers_content.data, async(value) => {
                            
                                if(!this.checkValue(value.period, periodContent)){
                                    periodContent.push(value.period)
                                }
                        })

                        _.each(offers_content.data, async(value) => {
                            
                                if(!this.checkValue(value.offer_id, offerIds)){
                                    offerIds.push(value.offer_id)
                                    let click = {
                                                    'name': value.offer_id,
                                                    'offer_id':value.offer_id,
                                                    'node_mac':value.node_mac,
                                                    'data': []
                                                }
                                    clicksChartData.push(click)
                                }
                        })

                        _.each(periodContent, (periodValue) => {

                            _.each(offerIds, (offerValue) => {

                                _.each(offers_content.data, (value) => {
                                    
                                        if(value.period===periodValue && value.offer_id==offerValue){

                                            _.each(clicksChartData, (valuedata, index) => {

                                                if(valuedata.offer_id==value.offer_id){
                                                    if(value.node_mac!==valuedata.node_mac){
                                                        clicksChartData[index].data[clicksChartData[index].data.length-1] = clicksChartData[index].data[clicksChartData[index].data.length-1] + value.clicks
                                                    }else{
                                                        clicksChartData[index].data.push(value.clicks)
                                                    }
                                                }
                                            })
                                        }
                                })
                            })
                        })

                        _.each(periodContent, (periodValue, indx) => {
                            let sumOffer = 0
                            _.each(clicksChartData, (valuedata, index) => {
                                _.each(valuedata.data, (value, idx) => {
                                    if(indx==idx){
                                        sumOffer = sumOffer+value
                                    }
                                })
                            })
                            clicksChartDataItems[0].data.push(sumOffer)
                        })

                        if(cluster.stores.length==cindex+1){

                            cluster.storeProm = ((totalSessionsProm/storeSessionsProm.length).toFixed(0)).toString()

                            cluster.totalConections = totalSessionsProm
                            
                            cluster.conexiones = total
                            cluster.conexiones_prom = ((totalSessionsProm/ cluster.stores.length).toFixed(0)).toString()

                            // Se calcula el total de visitantes 
                            // sumando los valores en el arreglo del cluster
                            cluster.visitantes = 0
                            _.each(storeRecurrentsProm, (value, i) => {
                                cluster.visitantes = cluster.visitantes + value
                            })
                            cluster.totalVisitors = cluster.visitantes
                            cluster.recurrentProm = (cluster.visitantes / cluster.stores.length).toFixed(0).toString() 

                            cluster.transeuntes = 0
                            _.each(storeNotRecurrentsProm, (value, i) => {
                                cluster.transeuntes = cluster.transeuntes + value
                            })
                            cluster.totalTrans = cluster.transeuntes
                            cluster.notRecurrentProm = (cluster.transeuntes / cluster.stores.length).toFixed(0).toString()
                            
                            

                            cluster.recurrents_prom = ((cluster.visitantes / cluster.stores.length).toFixed(0)).toString()
                            cluster.not_recurrents_prom = ((cluster.transeuntes / cluster.stores.length).toFixed(0)).toString()

                            cluster.revenue = 0
                            _.each(storeRevenue, (value, key) => {
                                cluster.revenue = cluster.revenue + value
                            })
                            cluster.revenue = (cluster.revenue).toFixed(0).toString()
                            
                            cluster.clicks = totalClicks

                            cluster.lineChartData = lineChartData
                            cluster.periodLineChartData = periodLineChartData
                        

                            cluster.barChartData = clicksChartDataItems,
                            cluster.periodBarChartData = periodContent,
                            
                            cluster.miliLineChartData = [{ 'data': revenueChartData, 'name': 'Conexiones' }]
                            cluster.periodMiniLineChartData = periodRevenue

                            loadedCount = loadedCount +1

                            if(loadedCount==clusters.length){
                                this.clusterArray = clusters
                                let clustersToExport = this.clusterArray

                                let periodRecurrentNotrecurrent = []

                                

                                _.each(clustersToExport, async(cluster, csindex) => {
                                    let spaceperiod = {}
                                    spaceperiod["Cluster"] = cluster.name
                                    spaceperiod["Sedes"] = this.thousandseparatos(cluster.clusters)
                                    spaceperiod["Conexiones"] = this.thousandseparatos(cluster.totalConections)
                                    spaceperiod["Visitantes"] = this.thousandseparatos(cluster.visitantes)
                                    spaceperiod["Transeúntes"] = this.thousandseparatos(cluster.transeuntes)
                                    spaceperiod["Promedio conexiones"] = this.thousandseparatos(cluster.conexiones_prom)
                                    spaceperiod["Promedio visitantes"] = this.thousandseparatos(cluster.recurrents_prom)
                                    spaceperiod["Promedio transeúntes"] = this.thousandseparatos(cluster.not_recurrents_prom)
                                    spaceperiod["Revenue por contenidos"] = this.thousandseparatos(cluster.revenue)
                                    spaceperiod["Interacciones por contenidos"] = this.thousandseparatos(cluster.clicks)
                                    
                                    periodRecurrentNotrecurrent.push(spaceperiod)
                                    
                                })

                                let csvContent = "data:text/csv;charset=utf-8,";
                                csvContent += [
                                Object.keys(periodRecurrentNotrecurrent[0]).join(";"),
                                ...periodRecurrentNotrecurrent.map(item => Object.values(item).join(";"))
                                ]
                                .join("\n")
                                .replace(/(^\[)|(\]$)/gm, "");

                                const data = encodeURI(csvContent);
                                const link = document.createElement("a");
                                link.setAttribute("href", data);
                                link.setAttribute("download", moment().format('DD-MM-YYYY')+"_Notros_Clusters.csv");
                                link.click();
                            }
                        }  
                    })
            });

        },
        ...mapActions('clusters', {
            'getClusters': 'clusterRequest',
            'setClusterFilter': 'setClusterFilter'
        }),
    },
}
</script>
<style lang="sass">
.card-data.download-card
    width: calc(100%/4)
    display: flex
    flex-wrap: wrap
    padding: 8px
    justify-content: center
    @include mobile
        width: calc(96%/2)
    @include mobile-landscape
        width: calc(96%/2)
    .header
        display: flex
        font-family: $title-font
        flex-direction: row
        width: 100%
        margin-bottom: 16px
        @include mobile
            flex-direction: column
            align-items: center
        .icon-holder
            font-size: 16px
            color: $secondary
            flex-grow: 1
            margin-right: 8px
            @include mobile
                margin-right: 0px
            .circle
                width: 40px
                height: 40px
                border-radius: 50%
                background: rgba(11,153,216,0.2)
                box-sizing: border-box
                .innercircle
                    width: 24px
                    height: 24px
                    border-radius: 50%
                    background: rgba(11,153,216,0.3)
                    position: relative
                    top: 8px
                    left: 8px
                    .icon
                        position: absolute
                        top: 4px
                        left: 4px
                        margin: 0
        
        .title-holder
            flex-grow: 2
            width: 80%
            @include mobile
                width: 100%
                margin-top: $xs
            .title
                font-size: 14px
                font-weight: 600
                width: 100%
                @include mobile
                    text-align: center
            .subtitle
                font-size: 14px
                font-weight: 200
                width: 100%
                @include mobile
                    text-align: center
    a.button
        @include mobile
            min-width: 128px
        @include mobile-landscape
            min-width: 128px
        @include tablet-portrait
            min-width: 128px

</style>